import { HeaderPage } from './header.constants'

export const TAB_SECTION: Record<HeaderPage, string> = {
  resources: 'resources',
  community: 'practitioners',
  skills: 'skills',
}
